import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberNotRound'
})
export class NumberNotRoundPipe implements PipeTransform {

  transform(value?: number, ...args: unknown[]): string {
    const valueString = value?.toString() ?? '0';
    const amount = parseFloat(valueString).toFixed(2);
    const formattedString = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return formattedString;
  }

}
